import { useId } from 'react'

import { getQaSelector } from '../../../utils/common'
import { EntityPhaseList, EntityPhaseListLoading } from '../../Entity'
import Text from '../../Text'

import { PhaseStrip } from './PhaseStrip'
import { usePhaseStrip } from './RentalPortalPhaseBar.hooks'
import {
  checkIsPhaseAwaitingApproval,
  getPhaseBarItems,
  getPhaseBarStatusText,
  getPhaseBarTabbableKey,
  getPhaseBarTooltipAdditionalText,
  getPhaseByKey,
} from './RentalPortalPhaseBar.utils'

import * as styles from './RentalPortalPhaseBar.module.css'

function RentalPortalPhaseBar({
  activePhaseKey,
  awaitingApprovalPhaseKey,
  isLoading,
  isPreview,
  isTerminal,
  items,
  phases,
  primaryAction,
  qaName,
  stripQaName,
  terminalStatement,
  withStrip,
  onRetry,
}) {
  const baseId = useId()

  const {
    handleKeyDownPhase,
    handleKeyDownStrip,
    handleTogglePhase,
    openPhaseKey,
  } = usePhaseStrip({
    activePhaseKey,
    barClassName: styles.RentalPortalPhaseBar,
    baseId,
    isPreview,
    phases,
  })

  const openPhase = getPhaseByKey({ phaseKey: openPhaseKey, phases })

  return isLoading || items?.length > 0 ? (
    <div
      {...getQaSelector({ value: qaName })}
      className={styles.RentalPortalPhaseBar}
    >
      {isLoading ? (
        <EntityPhaseListLoading />
      ) : (
        <EntityPhaseList
          getPhaseStatusText={getPhaseBarStatusText}
          getTooltipAdditionalText={getPhaseBarTooltipAdditionalText}
          items={getPhaseBarItems({
            baseId,
            items,
            tabbablePhaseKey: getPhaseBarTabbableKey({
              activePhaseKey,
              items,
              openPhaseKey,
            }),
            withStrip,
            onKeyDown: handleKeyDownPhase,
          })}
          phaseItemClassName={styles.phaseItem}
          showTooltip={false}
          value={openPhaseKey}
          onClick={withStrip ? handleTogglePhase : null}
        />
      )}

      {terminalStatement ? (
        <Text isSecondary className={styles.terminalStatement}>
          {terminalStatement}
        </Text>
      ) : null}

      {withStrip && (isLoading || openPhase) ? (
        <PhaseStrip
          isAwaitingApproval={checkIsPhaseAwaitingApproval({
            awaitingApprovalPhaseKey,
            openPhaseKey,
          })}
          isLoading={isLoading}
          isTerminal={isTerminal}
          phase={openPhase}
          primaryAction={primaryAction}
          qaName={stripQaName}
          onKeyDown={handleKeyDownStrip}
          onRetry={onRetry}
        />
      ) : null}
    </div>
  ) : null
}

export default RentalPortalPhaseBar
